export const webRequestTypeEnum = Object.freeze({
  Brochure: 'Brochure',
  TrialStay: 'TrialStay',
  Visit: 'Visit',
  OnlineCounseling: 'OnlineCounseling'
})
